<div *ngIf="starRating != null">
  <span *ngFor="let rating of ratings" class="me-1">
    <img *ngIf="rating <= starRating && !showHalfStar(starRating, rating)"
         alt="{{'productReview.filled' | cxTranslate}} {{'productReview.star' | cxTranslate}}"
         class="review-star"
         src="/assets/images/product/review/star-filled-review.svg"/>
    <img *ngIf="showHalfStar(starRating, rating)"
         alt="{{'productReview.half' | cxTranslate}} {{'productReview.star' | cxTranslate}}"
         class="review-star"
         src="/assets/images/product/review/star-half-review.svg"/>
    <img *ngIf="rating > starRating && !showHalfStar(starRating, rating)"
         alt="{{'productReview.empty' | cxTranslate}} {{'productReview.star' | cxTranslate}}"
         class="review-star"
         src="/assets/images/product/review/star-empty-review.svg"/>
  </span>
</div>
